import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import InfoIcon from '@material-ui/icons/Info';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ShareIcon from '@material-ui/icons/Share';
import { withStyles } from '@material-ui/core/styles';
import ShareOptions from './ShareOptions';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import links from 'utils/links';
import { getCityName } from 'utils/';

const styles = theme => ({
  cardContainer: {
    height: '100%',
    position: 'relative',
  },
  cardContent: {
    paddingBottom: '60px',
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    // maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 2 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
  actions: {
    marginTop: '20px',
    position: 'absolute',
    width: '100%',
    bottom: '0',
    backgroundColor: theme.palette.primary.main,
    height: '40px',
  },
  infoIcon: {
    color: theme.palette.secondary.main,
    fontSize: '0.5em',
  },
  actionIcon: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    margin: '5px',
    marginTop: '-30px',
    boxShadow: '1px 1px grey',
    '&:hover': {
      '@media': {
        backgroundColor: '#391b16',
      },
      '&:focus': {
        backgroundColor: 'grey',
      },
    },
  },
  actionButton: {
    position: 'absolute',
    left: -theme.spacing.unit * 3 - 4,
    top: 30,
    paddingLeft: theme.spacing.unit * 5,
    textTransform: 'none',
  },
  media: {
    height: 180,
    position: 'relative',
    width: '100%',
    marginTop: '-10px',
  },
  inline: {
    // display: 'inline',
    fontSize: '0.75rem',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    display: '-webkit-box',
    // maxHeight: '32px' /* fallback */,
    // WebkitLineClamp: 1 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
    marginTop: '8px',
  },
  pushRight: {
    marginLeft: 'auto',
  },
  experienceTitle: {
    justifyContent: 'space-between',
    fontSize: '1.125rem',
    fontWeight: 'medium',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
    // overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineHeight: 1,
    maxHeight: '26px' /* fallback */,
    WebkitLineClamp: 2 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
  experienceSummary: {
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    // lineHeight: '16px'
    lineHeight: '1.5rem',
    WebkitLineClamp: 2 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
});

class RnFExperience extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    let { classes, name, expType, img, summary, id, removable } = this.props;
    removable = removable ? removable : false;
    var cityName = getCityName().toLowerCase();
    if (cityName === 'bangalore') {
      cityName = 'bengaluru';
    }

    return (
      <Card className={classes.cardContainer}>
        <CardHeader
          title={
            <div className={classes.experienceTitle}>
              {name}
              {removable ? (
                <ClearIcon
                  className={classes.icon}
                  onClick={() => this.props.onRemove(id)}
                />
              ) : null}
            </div>
          }
          subheader={
            <div>
              <Typography
                variant="subtitle2"
                classes={{ root: classes.inline }}
              >
                {expType}
              </Typography>
            </div>
          }
        />
        <CardMedia
          className={classNames(classes.media)}
          image={img ? img : '/img/na.png'}
        >
          <a
            href={links.ourLiveExperienceCities(cityName)}
            className={classes.liveExperiencelink}
          >
            <Button
              className={classes.actionButton}
              color="secondary"
              variant="contained"
            >
              Book Now
            </Button>
          </a>
        </CardMedia>
        <CardContent className={classes.cardContent}>
          <Typography variant="body1" className={classes.experienceSummary}>
            {/* &#x201C; */}
            {summary}
            {/* &#x201D; */}
          </Typography>
          {/* <Typography align="right" variant="body2">
            …read more
          </Typography> */}
        </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>
          <IconButton className={classes.infoIcon} aria-label="Information">
            <InfoIcon />
          </IconButton>
          <div className={classes.pushRight}>
            {localStorage.getItem('tsUserInfo') ? (
              <IconButton
                className={classes.actionIcon}
                color="secondary"
                aria-label="Bookmark"
              >
                <BookmarkIcon />
              </IconButton>
            ) : (
              <React.Fragment>
                <IconButton
                  className={classes.actionIcon}
                  color="secondary"
                  aria-label="Bookmark"
                  onClick={this.handleClickOpen}
                >
                  <BookmarkIcon />
                </IconButton>
                <Dialog
                  open={this.state.open}
                  onClose={this.handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {'Talking Street '}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Please Sign-in or Sign-up to proceed/Bookmark
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.handleClose}
                      color="primary"
                      autoFocus
                    >
                      Ok
                    </Button>
                  </DialogActions>
                </Dialog>
              </React.Fragment>
            )}
            <ShareOptions
              shareButton={
                <IconButton className={classes.actionIcon} aria-label="Share">
                  <ShareIcon />
                </IconButton>
              }
            />
            <IconButton className={classes.actionIcon} aria-label="Location">
              <LocationOnIcon />
            </IconButton>
          </div>
        </CardActions>
      </Card>
    );
  }
}

RnFExperience.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RnFExperience);
